import React, { useState, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import './otp.scss'
import { checkForgotOtp, resendOtp, verfiyemail,sendOtp } from "../../services/auth.service"
import { toast } from "react-toastify";
import { selectProvider } from '../../slice/registerSlice';
import { useSelector, useDispatch } from "react-redux";
import { usersignup } from '../../services/auth.service';
import OtpInput from 'react-otp-input';
import { setLoader } from "../../slice/commonSlice";

const OTP = (props) => {
  const [otp, setOtp] = useState(null);
  const dispatch = useDispatch();

  const provider = useSelector(selectProvider);
  const [email,setEmail] = useState();

  useEffect(() => {
    const storedData = localStorage.getItem('emailForforget');
    setEmail(storedData)
  }, []); // Add an empty dependency array if you want the effect to run once when the component mounts


  const resendOTP = async () => {
    const storedData = localStorage.getItem('emailForforget');
    const combinedObject = {
      email: storedData,
    };
    try {
      await dispatch(setLoader(true));
      const res = await sendOtp(combinedObject)
      if (res?.data?.status === true) {
        toast.success(res.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        await dispatch(setLoader(false));
      } else {
        toast.warning(res.response.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        await dispatch(setLoader(false));
      }
    } catch (e) {
      await dispatch(setLoader(false));
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const storedData = localStorage.getItem('emailForforget');
    const combinedObject = {
      email: storedData,
      otp: otp
    };
    try {
      await dispatch(setLoader(true));

      const res = await verfiyemail(combinedObject)
      if (res?.data?.status === true) {
        toast.success(res.data.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        props.setSignUpModal(true)
        props.setUserVerifiyOtpModal(false)
        const result = await usersignup(provider);
        if(result?.data?.status === true){
          toast.success(result.data.message, {
            position: toast.POSITION.TOP_CENTER,
          });
        }else{
          toast.warning(result?.data?.message, {
            position: toast.POSITION.TOP_CENTER,
          });
        }
        await dispatch(setLoader(false));
      } else {
        toast.warning(res?.data?.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        await dispatch(setLoader(false));
      }
    } catch (e) {
      await dispatch(setLoader(false));
    }
  };

  return (
    <>
      <Modal
        size="sm"
        show={props.userVerifiyOtpModal}
        onHide={() => props.setUserVerifiyOtpModal(false)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body className='pt-0'>
          <h2 className='modal-title text-center'>Enter OTP</h2>
          <div className='modal-sub-title'>A One-time password will be sent <br /> to your email {email} </div>

          <Form onSubmit={(e) => handleSubmit(e)}>
            <div className='otp-form-wrapper'>
              {/* <div className='otp-title text-center'>OTP</div> */}
              <div className='otp-container'>
                <OtpInput
                  value={otp}
                  inputStyle='form-control'
                  containerStyle='otp-input-wrap'
                  onChange={setOtp}
                  numInputs={4}
                  inputType='tel'
                  skipDefaultStyles={true}
                  renderInput={(props) => <div><input {...props} /></div>}
                />
                <div className='form-footer text-end w-100' onClick={() => resendOTP()}><span>Resend?</span></div>
              </div>


            </div>
            <Form.Group className='mb-4'>
              <div className="d-grid">
                <Button type='submit' variant="primary" size="lg">
                  Submit
                </Button>
              </div>
            </Form.Group>
            <div className='form-footer text-center w-100 mb-2' onClick={() => { props.setSignUpModal(true); props.setOtpModal(false) }}>Back to login? <span>Login page</span></div>
          </Form>

        </Modal.Body>
      </Modal>
    </>
  )
}

export default OTP
